// "Show me where this came from", as an icon.
//
// It was a text button repeated on every reading, every category and every
// block — the same four words a dozen times down a page whose actual job is to
// present decisions. An icon with a tooltip says the same thing, once, in the
// space of a glyph, and stops competing with Accept and Reject for attention.
//
// An eye rather than a page: the action is LOOKING at the source, not opening a
// document. The tooltip names the page number, because "show me" and "show me
// page 7 of 24" are different amounts of help.
import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraIconButton, SpecraTooltip } from '@mono/ui-components';
import { Eye } from 'lucide-react';
export function ShowOnPageButton({ onClick, page, testId, what }) {
    const label = page ? `Show ${what ?? 'this'} on page ${page} of the document` : `Show ${what ?? 'this'} on the page`;
    return /*#__PURE__*/ _jsx(SpecraTooltip, {
        content: label,
        children: /*#__PURE__*/ _jsx(SpecraIconButton, {
            "data-testid": testId,
            label: label,
            onClick: onClick,
            size: "sm",
            variant: "ghost",
            children: /*#__PURE__*/ _jsx(Eye, {
                "aria-hidden": true,
                className: "size-4"
            })
        })
    });
}
